import React from "react";
import Slider from "react-slick";
import { Box } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImageSlider = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const images = [
        "/images/slider1.jpg",
        "/images/slider3.jpg",
        "/images/slider4.png",
    ];

    return (
        <Box
            sx={{
                width: {
                    xs: "390px",     // Mobil ekranlar
                    sm: "500px",      // Küçük tablet
                    md: "850px",    // Orta ekran
                    lg: "850px",    // Büyük ekran
                },
                height: "96%",
                mx: "auto",         // Ortalamak için
                borderRadius: 2,
                overflow: "hidden",
            }}
        >
            <Slider {...settings}>
                {images.map((image, index) => (
                    <Box key={index} component="img" src={image} alt={`Slider image ${index + 1}`} sx={{ width: "100%", height: "auto" }} />
                ))}
            </Slider>
        </Box>
    );
};

export default ImageSlider;